import React from "react";

import FanPermission from "../FanPermission";

const FanSettings = () => {
  return (
    <div style={{ width: "100%" }}>
      <FanPermission />
    </div>
  );
};

export default FanSettings;
